import { render } from "./Sms.vue?vue&type=template&id=3cf335cf&scoped=true"
import script from "./Sms.vue?vue&type=script&lang=js"
export * from "./Sms.vue?vue&type=script&lang=js"

import "./Sms.vue?vue&type=style&index=0&id=3cf335cf&scoped=true&lang=css"
import "./Sms.vue?vue&type=style&index=1&id=3cf335cf&lang=css"

import exportComponent from "/root/workspace/Collection_EVMd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cf335cf"]])

export default __exports__